export const SPACE_SIZE = 10
